/** A workspace's or a project's mark square (2026-10-20): its logo when it has one, else its initials. The picture is decorative (alt
 *  empty): the name always stands beside it or in the control's label. */
export function Mark({ mark, logo, large }: { mark: string; logo?: string | null; large?: boolean }) {
  const cls = `ob-mark${large ? " ob-mark--lg" : ""}${logo ? " ob-mark--logo" : ""}`;
  return <span className={cls}>{logo ? <img className="ob-mark__img" src={logo} alt="" /> : mark}</span>;
}
